(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tickerWrapper = document.querySelector('.ticker-wrapper');
  const tickerContainer = document.querySelector('.ticker-container');

  if (!tickerWrapper || !tickerContainer) return;

  const tickerWidth = tickerWrapper.offsetWidth;
  const containerWidth = tickerContainer.offsetWidth;

  // Adjust duration based on content width
  const duration = Math.max(15, tickerWidth / 100);
  tickerWrapper.style.animationDuration = duration + 's';

  // Duplicate items for smooth infinite scroll if content is short
  if (tickerWidth < containerWidth * 3) {
    const items = Array.from(tickerWrapper.children);
    items.forEach(item => {
      tickerWrapper.appendChild(item.cloneNode(true));
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
